import React, { useState, useCallback } from "react";
import { Outlet } from "react-router-dom";
import Sidebar from "../components/Sidebar";
import { Col, Row } from "react-bootstrap";

const Mainlayout = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const toggleSidebar = useCallback(() => setSidebarOpen((prev) => !prev), []);
  const closeSidebar = useCallback(() => setSidebarOpen(false), []);

  return (
    <Row className="gx-0 bg-gradient-black">
      {sidebarOpen && (
        <div className="sidebar-backdrop" onClick={closeSidebar} />
      )}
      <Col xl={2} className={sidebarOpen ? "" : "d-none d-xl-block"}>
        <Sidebar isOpen={sidebarOpen} onClose={closeSidebar} />
      </Col>
      <Col xl={10} className="main-content">
        <Outlet context={{ toggleSidebar }} />
      </Col>
    </Row>
  );
};

export default Mainlayout;
